import React, { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import { Image } from 'primereact/image';
import logoImg from '../../../assets/images/logo.png';
import moment from 'moment/moment';
import { Tag } from 'primereact/tag';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import handleDateSelect from '../../../helper/convertDateIntoPSTFormat';

const ReportTemplate = (props) => {

    console.log("ShowReport", props);
    const { reportId = '', schoolOrDeptName = '', requestDate = '', status = '', purpose = '', reportInformation = [], fundingDetails = [], specifyPurpose = '', approvalFinalData = [], events = [] } = props;

    let isRejectedForm = props.approvalFinalData.find(o => o.isApproved === false)

    const rejectedData = events.filter(item => item.status === 'Rejected')
    const approvedData = events.filter(item => item.isApproved === true)

    // let isApprovedForm = props.approvalFinalData.find(o => o.isApproved === true)


    return (
        <div>
            <div className="border m-4">
                <div className='text-center py-8'>
                    <Link to={""}><Image src={logoImg} width={"104"} height={"105"} imageClassName='m-auto' /></Link>
                    <div>
                        <div className="font-bold text-lg">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                        <div className="font-semibold text-base">Preparing our students for their future</div>
                        <div className="font-light text-sm">
                            <div>Office of the Chief Human Resources & Operations Officer</div>
                            <div>223 North Jackson St. Glendale, California 91206-4380</div>
                            <div>Telephone:818-241-3111,Ext.1256 Fax:818-547-3207</div>
                        </div>
                    </div>
                    <div className="my-4 font-bold text-xl">
                        Substitute Request - Certificated
                    </div>
                </div>

                <div className="pt-3 mx-8">
                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                        <div className="font-medium">School or Department </div>
                        <div className="font-semibold ">{schoolOrDeptName}</div>
                    </div>
                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                        <div className="font-medium">Date </div>
                        <div className="font-semibold ">{requestDate}</div>
                    </div>

                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                        <div className="font-medium">Status </div>
                        <Tag severity="" value={status} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                        {/* <div >Approved</div> */}
                    </div>
                </div>

                {/* <div className="card pt-3 mx-4">
                    <DataTable value={reportInformation}>
                        <Column field="teacherName" header="Teacher(s) Name" sortable ></Column>
                        <Column field="datesNeeded" header="Date(s) Needed" sortable ></Column>
                        <Column field="indicateIf" header="Indicate If" sortable ></Column>
                        <Column field="gradeOrSubject" header="Grade(element) or Subject(second)" sortable ></Column>
                        <Column field="notes" header="Notes" sortable ></Column>
                    </DataTable>
                </div> */}
                <div>
                    <Table className="certificatedPrintTable">
                        <TableHead>
                            <TableRow>
                                <TableCell>Teacher(s) Name</TableCell>
                                <TableCell>Date(s) Needed</TableCell>
                                <TableCell>Indicate If</TableCell>
                                <TableCell>Grade(element) or Subject(second)</TableCell>
                                <TableCell>Notes</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {reportInformation.map((item, i) => (
                                <Fragment>
                                    <TableRow>
                                        <TableCell className="bg-[#F2F4F7]"
                                        >
                                            {item.teacherName}
                                        </TableCell>

                                        <TableCell className="w-[180px]">
                                            {item.datesNeeded.map((date, detailIndex) => (

                                                <TableRow key={detailIndex} className="bg-[#F2F4F7]">
                                                    <TableCell>{moment(date).format('MM/DD/YYYY')}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableCell>
                                        <TableCell className="bg-[#F2F4F7]"
                                        >
                                            {item.indicateIf}
                                        </TableCell>
                                        <TableCell className="bg-[#F2F4F7]"
                                        >
                                            {item.gradeOrSubject}
                                        </TableCell>
                                        <TableCell className="bg-[#F2F4F7]"
                                        >
                                            {item.notes}
                                        </TableCell>
                                    </TableRow>
                                </Fragment>
                            ))}
                        </TableBody>
                    </Table>
                </div>

                <div className="pt-3 mx-8">
                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                        <div className="font-medium">Purpose</div>
                        <div className="font-semibold ">{specifyPurpose}</div>
                    </div>
                    <div className="text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                        <div className="font-medium">Funding Account</div>


                        {
                            fundingDetails.map((currentItem, index) => {
                                return (
                                    <div key={index}>
                                        <div className="flex justify-between my-3">
                                            <div className="font-light">Department</div>
                                            <div className="font-semibold ">{currentItem.departmentName}</div>
                                        </div>
                                        <div className="flex justify-between">
                                            <div className="font-light">Remark</div>
                                            <div className="font-semibold ">{currentItem.remark ? currentItem.remark : '-'}</div>
                                        </div>
                                        <div className="flex justify-between">
                                            <div className="font-light">Program Account #</div>
                                            <div className="font-semibold ">{currentItem.programAccountNumber}</div>
                                        </div>
                                        <div className="flex justify-between">
                                            <div className="font-light">percentage</div>
                                            <div className="font-semibold ">{currentItem.percentage}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }


                    </div>
                </div>
            </div>
            {/* Revised 1/17/23 */}
            <div className='float-right'>
                {
                    (props.submittedBy) ?
                        <div>
                            <span className='float-left mr-3 font font-bold'>{'Submitted by:'}</span><br />
                            <span className='font'>{props.submittedBy.empName ? props.submittedBy.empName : null}
                                &nbsp;
                                {props.submittedBy.date ? (props.submittedBy.date) : null}
                                <br />
                            </span></div> : null
                }


                {/* {
                    isApprovedForm ? <><span className='float-left mr-3 font font-bold'>{`Approved by:`}</span><br /></> : ''
                }
                

                {
                    props.approvalFinalData.map((data, index) => {
                        return (
                            <> */}
                {/* {data.status === "Approved" ?
                                  <span className='float-right mr-3 font'>{data.teacherName ? data.teacherName : null} 
                                  {data.updatedAT ? moment(data.updatedAT, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A"): null}
                                  </span>
                                  <br/>
                                : 
                                null} */}


                {/* {data.isApproved ?
                                    <span className='font'>{data.empName ? data.empName : null} &nbsp;
                                        {data.updatedAt ? handleDateSelect(data.updatedAt) : null}
                                        <br />
                                    </span>
                                    : null}
                            </>
                        )
                    })
                } */}

                {
                    approvedData.length > 0 ? <><span className='float-left mr-3 font font-bold'>{`Approved by:`}</span><br /></> : ''
                }
                {approvedData.length > 0 ? (
                    approvedData.map((item, index) => (
                        <span className='font' key={index}>
                            {item.empName ? item.empName : '-'}&nbsp;
                            {/* {item.date ? handleDateSelect(item.date) : null} */}
                            {item.date ? item.date : null}

                            <br />
                        </span>
                    ))
                ) : null}



                {
                    rejectedData.length > 0 ? <><span className='float-left mr-3 font font-bold'>{`Rejected by:`}</span><br /></> : ''
                }

                <>
                    {/* {data.status === "Approved" ?
                                  <span className='float-right mr-3 font'>{data.teacherName ? data.teacherName : null} 
                                  {data.updatedAT ? moment(data.updatedAT, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A"): null}
                                  </span>
                                  <br/>
                                : 
                                null} */}

                    {rejectedData.length > 0 ? (
                        rejectedData.map((item, index) => (
                            <span className='font' key={index}>
                                {item.empName ? item.empName : '-'}&nbsp;
                                {/* {item.date ? handleDateSelect(item.date) : null} */}
                                {item.date ? item.date : null}

                                <br />
                            </span>
                        ))
                    ) : null}
                </>

            </div>
        </div>
    )
}

export default ReportTemplate